const messages = {
  title: "Par BS Plus",
  description: "About page description",
};

export default {
  messages,
};
